import type { Passbook } from '@/shared/types';
import { Input } from '@/shared/ui/input';
import { Label } from '@/shared/ui/label';
import { Textarea } from '@/shared/ui/textarea';
import { surveyBonusUnit } from '../model/survey-bonus';

export interface SurveyCardValues {
  messageSurvey: string;
  titleLinkSurvey: string;
  mensagemBonificacaoNPS: string;
  /** String para aceitar "2,5" de cashback enquanto digita. */
  qtdeBonificarNPS: string;
}

interface Props {
  values: SurveyCardValues;
  onChange: (patch: Partial<SurveyCardValues>) => void;
  passbook?: Pick<Passbook, 'hasPoints' | 'hasCashback' | 'regraCartao'>;
  disabled?: boolean;
  /** Prefixo para ids únicos quando o bloco aparece duas vezes na mesma tela. */
  idPrefix?: string;
}

/** Os 4 campos da pesquisa no cartão (`regraCartao`): texto/link do convite e bonificação. */
export function SurveyCardFields({ values, onChange, passbook, disabled, idPrefix = 'survey' }: Props) {
  const unit = surveyBonusUnit(passbook);
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      <div className="space-y-1.5 sm:col-span-2">
        <Label htmlFor={`${idPrefix}-message`}>Texto no e-mail</Label>
        <Textarea
          id={`${idPrefix}-message`}
          value={values.messageSurvey}
          onChange={(e) => onChange({ messageSurvey: e.target.value })}
          rows={2}
          disabled={disabled}
        />
      </div>
      <div className="space-y-1.5 sm:col-span-2">
        <Label htmlFor={`${idPrefix}-link-title`}>Título do link</Label>
        <Input
          id={`${idPrefix}-link-title`}
          value={values.titleLinkSurvey}
          onChange={(e) => onChange({ titleLinkSurvey: e.target.value })}
          disabled={disabled}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor={`${idPrefix}-bonus-qty`}>{unit.label}</Label>
        <Input
          id={`${idPrefix}-bonus-qty`}
          inputMode="decimal"
          value={values.qtdeBonificarNPS}
          onChange={(e) => onChange({ qtdeBonificarNPS: e.target.value })}
          placeholder="0"
          disabled={disabled}
        />
        <p className="text-xs text-muted-foreground">{unit.hint} Deixe 0 para não bonificar.</p>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor={`${idPrefix}-bonus-message`}>Mensagem da bonificação</Label>
        <Input
          id={`${idPrefix}-bonus-message`}
          value={values.mensagemBonificacaoNPS}
          onChange={(e) => onChange({ mensagemBonificacaoNPS: e.target.value })}
          disabled={disabled}
        />
        <p className="text-xs text-muted-foreground">Aparece no extrato de quem respondeu.</p>
      </div>
    </div>
  );
}
